import { initializeApp, getApps } from "firebase/app";
import { getMessaging, onMessage, type Messaging } from "firebase/messaging";

declare module "#app" {
  interface NuxtApp {
    $messaging: Messaging;
  }
}

declare module "vue" {
  interface ComponentCustomProperties {
    $messaging: Messaging;
  }
}

export default defineNuxtPlugin(() => {
  const runtimeConfigPublic = useRuntimeConfig().public;

  // Skip if Firebase config is missing (e.g. in tests or incomplete env)
  if (!runtimeConfigPublic.firebaseProjectId) {
    return;
  }

  const app =
    getApps()[0] ??
    initializeApp({
      apiKey: runtimeConfigPublic.firebaseApiKey,
      authDomain: runtimeConfigPublic.firebaseAuthDomain,
      projectId: runtimeConfigPublic.firebaseProjectId,
      storageBucket: runtimeConfigPublic.firebaseStorageBucket,
      messagingSenderId: runtimeConfigPublic.firebaseMessagingSenderId,
      appId: runtimeConfigPublic.firebaseAppId,
      measurementId: runtimeConfigPublic.firebaseMeasurementId,
    });

  const messaging = getMessaging(app);
  const firebase = useFirebase();

  // Foreground handler for all supported web contexts.
  onMessage(messaging, (payload) => {
    const payloadString = JSON.stringify(payload, null, 2);
    firebase.onMessage(payloadString);
  });

  // Keep token registered for users who already granted notification permission.
  if (
    import.meta.client &&
    window.Notification?.permission === "granted"
  ) {
    firebase.updateTokensInDatabase();
  }

  return {
    provide: {
      messaging,
    },
  };
});
